import { fetcher } from '@commenda/utils';
import { CreateSecureInformationRequestTemplateArgs } from './types';

export async function createSecureInformationRequestTemplate(
  body: CreateSecureInformationRequestTemplateArgs,
  token: string
) {
  const response = await fetcher(
    `secureInformationRequestTemplate/`,
    {
      method: 'POST',
      body,
    },
    token
  );

  return response;
}
